import { useEffect, useState } from 'react';

import vehiclesMap from '../../store/vehiclesMap';
import user from '../../store/user';

function useTrips(idPlate) {
    const [trips, setTrips] = useState([]);
    const [, useVehiclesMap] = vehiclesMap();
    const [userStore] = user();
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (!userStore?.token) return;
        setLoading(true);
        useVehiclesMap
            .getTripsVehicle(userStore.token, idPlate)
            .then((res) => {
                setTrips(res?.trips || []);
                setLoading(false);
            })
            .catch((e) => {
                if (e.status === 401) {
                    setLoading(false);

                    return;
                }
            });
    }, [userStore?.token, idPlate]);


    return {
        trips,
        loading
    };
}

export default useTrips;